import { GET_MATCH_INFO, SET_MATCH_PLAYERS } from './matchVcard.types';

const initState = {
  matchInfo: {},
  matchPlayers: {
    homePlayers: {
      players: [],
      name: '',
    },
    awayPlayers: {
      players: [],
      name: '',
    },
  },
};

export default (state = initState, action) => {
  switch (action.type) {
    case GET_MATCH_INFO:
      return {
        ...state,
        matchInfo: action.payload,
      };
    case SET_MATCH_PLAYERS:
      return {
        ...state,
        matchPlayers: {
          homePlayers: action.payload.homePlayers,
          awayPlayers: action.payload.awayPlayers,
        },
      };
    default:
      return state;
  }
};
